import { styled } from 'dripsy';
import React, { forwardRef, useImperativeHandle } from 'react';
import { View } from 'react-native';
import { nanoid } from 'nanoid/non-secure';

import { Separator } from '../../common/Separator';
import { BaseText } from '../../common/BaseText';
import {
  IPlayerSliderBubbleProps,
  PlayerSliderBubbleRefType,
} from './PlayerSliderBubble';
import { useVar } from '@hooks';

const Container = styled(View)({
  alignItems: 'center',
  justifyContent: 'center',
});

const Text = styled(BaseText)({
  color: '$background0',
  variant: 'text.small',
  textAlign: 'center',
});

export const PlayerSliderBubble = forwardRef<
  PlayerSliderBubbleRefType,
  IPlayerSliderBubbleProps
>(({ hasTimestamps }, ref) => {
  const timestampTimeId = useVar(nanoid());
  const timestampTextId = useVar(nanoid());

  useImperativeHandle(ref, () => ({
    setText: (time: string, timestamp?: string) => {
      const timestampTimeElement =
        document.getElementById(timestampTimeId);
      const timestampTextElement =
        document.getElementById(timestampTextId);

      if (timestampTimeElement) {
        timestampTimeElement.textContent = time;
      }

      if (timestampTextElement) {
        timestampTextElement.textContent = timestamp ?? null;
      }
    },
  }));

  return (
    <Container>
      {hasTimestamps && <Text nativeID={timestampTextId} />}
      <Separator size="$2" />
      <Text nativeID={timestampTimeId} />
    </Container>
  );
});
